/**
 * Validate one-time password (OTP)
 * The trimmed OTP should be between 1 and 50 characters long
 * TODO: Add some test and improve the validation once we have the real spec
 */
function validateOtp(otp: string): boolean {
  const trimmedOtp = otp.trim();
  return trimmedOtp.length > 0 && trimmedOtp.length <= 50;
}

export {validateOtp};
